import React, { FC } from 'react';
import cls from './ArrowBlock.module.css';
import classNames from 'classnames';

export const ArrowBlock = ({ isShow }) => {
    return (
        <div className={classNames(cls.ArrowBlock, { [cls.show]: isShow })}>
            <span className={classNames({ [cls.show]: isShow })}>
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.4026 8L5.33594 4.93333L6.26927 4L10.2693 8L6.26927 12L5.33594 11.0667L8.4026 8Z"
                        fill="#252733"
                    />
                </svg>
            </span>
        </div>
    );
};
